// extracted by css-extract-rspack-plugin
export default {"toggle":"ThemeToggle-module__toggle___hUA8h"};